export const RANGE = {
  all: "all",
  last7: "last7",
  last30: "last30",
  custom: "custom",
};

export const NO_TAG = "__no_tag__";
export const NO_TAG_LABEL = "Ohne Tag";

export const EMPTY_FILTER = { range: { kind: RANGE.all }, tags: [] };

export const isFilterActive = (filter) =>
  (filter?.range?.kind ?? RANGE.all) !== RANGE.all ||
  (filter?.tags?.length ?? 0) > 0;
